import {
  LOCALE_BY_SOURCE_CURRENCY,
  VIRTUAL_ACCOUNT_LABEL,
} from '~/app/settings/team/banks/constants'
import {
  VirtualAccount,
  VirtualAccountDepositInstructions,
} from '~/components/VirtualAccounts'
import { Tabs, TabsContent } from '~/components/component-library'
import { SplitsDialogContent } from '~/components/component-library/Dialog'
import { SetupBankTransfersDialog } from '~/components/smart-accounts/SetupBankTransfersDialog'
import { useCanOfframpOrOnramp } from '~/components/smart-accounts/useCanOfframpOrOnramp'
import { useActiveOrg } from '~/hooks/org'
import { BridgeVirtualAccount } from '~/types'

export const OnrampDialog = () => {
  const { org } = useActiveOrg()

  const canOnramp = useCanOfframpOrOnramp()

  if (!canOnramp) return null

  const hasVirtualAccounts =
    !!org?.bridge?.virtualAccounts && org.bridge.virtualAccounts.length > 0

  if (hasVirtualAccounts) {
    const virtualAccounts = org.bridge?.virtualAccounts ?? []

    const renderVirtualAccount = (virtualAccount: BridgeVirtualAccount) => {
      return (
        <div className="space-y-4">
          <VirtualAccountDepositInstructions
            currency={virtualAccount.sourceData.currency}
          />
          <VirtualAccount virtualAccount={virtualAccount} withForm={false} />
        </div>
      )
    }

    return (
      <SplitsDialogContent title="Onramp" id="onramp-dialog" variant="info">
        {virtualAccounts.length === 1 &&
          renderVirtualAccount(virtualAccounts[0])}
        {virtualAccounts.length > 1 && (
          <Tabs
            defaultValue={virtualAccounts[0].id}
            options={virtualAccounts.map((virtualAccount) => ({
              value: virtualAccount.id,
              display:
                VIRTUAL_ACCOUNT_LABEL[
                  LOCALE_BY_SOURCE_CURRENCY[virtualAccount.sourceData.currency]
                ] ?? virtualAccount.sourceData.currency,
            }))}
          >
            {virtualAccounts.map((virtualAccount) => (
              <TabsContent key={virtualAccount.id} value={virtualAccount.id}>
                {renderVirtualAccount(virtualAccount)}
              </TabsContent>
            ))}
          </Tabs>
        )}
      </SplitsDialogContent>
    )
  } else {
    return <SetupBankTransfersDialog isOnramp />
  }
}
